import { render, staticRenderFns } from "./UserRoster.vue?vue&type=template&id=5d6adea0"
import script from "./UserRoster.vue?vue&type=script&lang=js"
export * from "./UserRoster.vue?vue&type=script&lang=js"
import style0 from "./UserRoster.vue?vue&type=style&index=0&id=5d6adea0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports